export const DEFAULT_SORT = {
  field: 'name',
  order: 'ascend',
};
